import React, { Component } from 'react';
import { MultiSelect } from 'primereact/multiselect';

class ListShared extends Component {

    constructor(props) {
        super(props);
        this.state = { values: null, selected: null, form: null };
    }


    componentDidMount() {
        var values = JSON.parse(this.props.values);
        var selected = JSON.parse(this.props.selected);
        var form = this.props.form;

        this.setState({
            values: values,
            selected: selected,
            form: form
        });

    }

    render() {
        return (
            <div>
                <span className="p-fluid">
                    <MultiSelect value={this.state.selected} options={this.state.values} onChange={(e) => this.setState({ selected: e.value })} optionLabel="name" placeholder="Select" filter selectedItemTemplate={this.selectedValuesTemplate}  />
                    <input name='list_shared' type="hidden" value={JSON.stringify(this.state.selected)} form={this.state.form} />
                </span>
            </div>
        )
    }
}

export default ListShared;